import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CredentialsService } from '@app/features/auth/credentials.service';
import { RefundService } from '@app/shared/services';
import { environment } from '@env/environment';
import { map, mergeMap, of, delay } from 'rxjs';

@Component({
  selector: 'app-claim-type',
  imports: [RouterModule, NgIf],
  templateUrl: './claim-type.component.html',
  styleUrl: './claim-type.component.scss',
})
export class ClaimTypeComponent implements OnInit {
  public assistType: 'medical' | 'travel' | null = null;

  public idAssist!: string;
  public credential: any;

  constructor(
    private refundSrv: RefundService,
    private credSrv: CredentialsService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.credential = this.credSrv.credentials;
  }

  ngOnInit(): void {
    this.idAssist = this.route.snapshot.params['id'];

    this.refundSrv.assistance$
      .pipe(
        mergeMap((resp) =>
          resp
            ? of(resp)
            : this.refundSrv.getAssistanceById(
                this.idAssist.toString(),
                this.credential.crmObjId,
              ),
        ),
        map((resp) => {
          return resp.assistType === environment.assistType.medical
            ? 'medical'
            : 'travel';
        }),
        delay(0),
      )
      .subscribe({
        next: (type) => (this.assistType = type),
        error: () => this.router.navigate(['/refund/', this.idAssist]),
      });
  }

  goNext() {
    this.router.navigate(['steps'], { relativeTo: this.route });
  }
}
